import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Course, Item, Section } from 'src/@types/Course';
import axiosInstance from 'src/utils/axios';
import uuid from 'react-uuid';

import { APIS } from 'src/utils/serviceUrls';
import { useSnackbar } from 'notistack';
type sectionIndexType = {
  section: Section;
  index: number;
};
export const useCourseView = () => {
  const params = useParams();
  const { enqueueSnackbar } = useSnackbar();
   const [currentItem, setCurrentItem] = useState<{ item: Item; index: number } | undefined>(
     undefined
   );
  const [modalOpen, setModalOpen] = useState(false);
      const [modalStep, setModalStep] = useState(currentItem ? 1 : 0);

  const [sectionModalOpen, SetSectionModalOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState<sectionIndexType | undefined>();

  const [currentCourse, setCurrentCourse] = useState<Course | undefined>();
  useEffect(() => {
    getCourse(params?.id as string).catch(console.error);
  }, []);
  const getCourse = async (id: string) => {
    const response = await axiosInstance.get(APIS.COURSES.BY_ID(id));
    setCurrentCourse(response.data.data);
  };

  const editCourse = async (newCourse: any) => {
    try
    {
      const response = await axiosInstance.patch(
        APIS.COURSES.PATCH(params.id as string),
        newCourse
      );
      setCurrentCourse(response.data.data);
      return response;
    }
    catch (err)
    {
      if (err?.message) {
        enqueueSnackbar(err?.message, { variant: 'error' });
      }

      if (err?.messages.length && err?.messages[0]) {
        enqueueSnackbar(err?.messages.length && err?.messages[0], { variant: 'error' });
      } else {
        enqueueSnackbar('Unable to Edit Course!', {
          variant: 'error',
        });
      }
    }
  };

  const onSubmitNewSection = async (data: Section) => {
    const newCourse = {
      ...currentCourse,
      track: currentCourse?.track?._id,
      instructor: currentCourse?.instructor?._id,
      package: currentCourse?.package?._id,
      rating: currentCourse?.rating == 0 ? 1 : currentCourse?.rating,
    };
    if (currentSection) {
      if (newCourse?.sections) {
        newCourse.sections[currentSection.index] = data;
      }
    } else newCourse.sections?.push(data);

    await editCourse(newCourse);
    SetSectionModalOpen(false);
  };

  const onSubmitNewSectionItem = async (data: Item, itemIndex: number | undefined,isDocument?:boolean) => {
    let itemData = { ...data };
    if (isDocument)
      itemData={ ...data,duration:1 }
    if (!data.uuid) {
      itemData = { ...itemData, uuid: uuid() };
    }
   
    let newCourse: any = JSON.parse(JSON.stringify(currentCourse));
  newCourse = {
    ...newCourse,
    track: currentCourse?.track?._id,
    instructor: currentCourse?.instructor?._id,
    package: currentCourse?.package?._id,
    rating: currentCourse?.rating == 0 ? 1 : currentCourse?.rating,
  };
    
 
    const sections = [...(newCourse?.sections ?? [])];
    if (itemIndex !== undefined && sections && currentSection)
    {
      const items = [...(sections?.[currentSection.index].items ?? [])];
      if (items)
      {
        items[itemIndex] = itemData;
        if (sections[currentSection.index]) sections[currentSection.index].items = items;
      }
    }
    else if (currentSection) sections[currentSection.index].items?.push(itemData);

    try
    {
      const response = await editCourse(newCourse);
      if (response?.status !=400)
      {
        setCurrentSection(response?.data?.data?.sections[currentSection?.index as number]);
        SetSectionModalOpen(false);
        setModalOpen(false);
        setCurrentItem(undefined)
        setModalStep(0);
        }
    } catch {
      
    }
  };
  const onDeleteSection = async () => {
    const newCourse = {
      ...currentCourse,
      track: currentCourse?.track?._id,
      instructor: currentCourse?.instructor?._id,
      package: currentCourse?.package?._id,
      rating: currentCourse?.rating == 0 ? 1 : currentCourse?.rating,
    };
    const uuids :string[]= []
    const sections = [...(newCourse.sections ?? [])];
     sections?.[currentSection?.index as number]?.items?.map((item: any) => {
       uuids.push(item?.uuid)
     });
    sections.splice(currentSection?.index as number, 1);
    newCourse.sections = sections;
    try {
      
      await editCourse(newCourse);
    await axiosInstance.post(APIS.SUPPORT.handleDelete, {
      uuid: uuids as any,
      type: 'SECTION',
      path:currentCourse?.category?._id
    });
      SetSectionModalOpen(false);
    } catch {
      console.log("errorr")
    }
  };
  const onDeleteItem = async (itemIndex: number, sectionIndex: number) => {
    const newCourse = {
      ...currentCourse,
      track: currentCourse?.track?._id,
      instructor: currentCourse?.instructor?._id,
      package: currentCourse?.package?._id,
      rating: currentCourse?.rating == 0 ? 1 : currentCourse?.rating,
    };
    const sections = [...(newCourse.sections ?? [])];
    let uuid=''
    if (sectionIndex >= 0)
    {   uuid = sections?.[sectionIndex]?.items?.[itemIndex]?.uuid??"";
      sections?.[sectionIndex]?.items?.splice(itemIndex, 1);

          newCourse.sections = sections;

      }
    try {
  
      const response = await editCourse(newCourse);
       await axiosInstance.post(APIS.SUPPORT.handleDelete, {
         uuid: [uuid as any],
         type: 'ITEM',
         path: currentCourse?.category?._id,
       });
      if (response)
        setCurrentSection(
          response.data?.data?.sections[(currentSection as sectionIndexType).index as number]
        );
    } catch {
      
}
  };
  const onGoUpDown = async (fromIndex: number, toIndex: number) => {

    const sectionItems = currentSection?.section.items as Item[];
    const element = sectionItems.splice(fromIndex, 1)[0];
    sectionItems.splice(toIndex, 0, element);
    setCurrentSection({
      section: { ...currentSection?.section, items: sectionItems } as Section,
      index: currentSection?.index as number,
    });
    let sections: Section[] = currentCourse?.sections as Section[];
    const index = currentSection?.index as number;
    let sectionSelect = (sections?.[index]).items as Item[]
    sectionSelect = sectionItems;
    sections[index].items = sectionSelect;
    let course = { ...currentCourse }
    course.sections=sections
    await editCourse({
      ...course,
      track: course.track?._id,
      instructor: course.instructor?._id,
      package:course?.package?._id
    })

    
   
  };

  return {
    onSubmitNewSection,
    onSubmitNewSectionItem,
    sectionModalOpen,
    setCurrentSection,
    SetSectionModalOpen,
    currentCourse,
    currentSection,
    onDeleteSection,
    onDeleteItem,
    modalOpen,
    setModalOpen,
    modalStep,
    setModalStep,
    currentItem,
    setCurrentItem,
    onGoUpDown,
  };
};
